import React from "react";
import { Button, Typography } from "components/atoms";
import {
  CloseIcon,
} from "components/atoms/Icon";
import {useAppDispatch} from "../../../../hooks";
import {setMcatChatAuthInfo, setShowMcatChatErrorModal} from "../../../../state/reducers/AuthSlice";
import {Modal} from "../../../molecules/Modal";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
  isOpen: boolean;
  onClose: () => void;
}

export const AIMCATErrorAlert = ({ theme, isOpen, onClose }: IProps) => {

  const dispatch: any = useAppDispatch();

  const onCloseErrorAlert = () => {
    dispatch(setShowMcatChatErrorModal(false));
    dispatch(setMcatChatAuthInfo({isMcatChatSessionEnd: false}));
    onClose();
  }

  return (
      <Modal
          theme={theme}
          closeOnOutsideClick={false}
          isOpen={isOpen}
          onClose={onCloseErrorAlert}
          style="error-modal-custom-style"
      >
        <div className="error-modal-container">
          <div className="error-modal">
            <div className="error-modal-header">
              <div className="error-modal-header-typography">
                <div className="title-typography-wrapper">
                  <Typography
                      label="Error Message"
                      variant="h6Medium"
                      styles="error-modal-header-typography-custom-style"
                  />
                </div>
              </div>
              <div
                  className="error-modal-header-close-icon"
                  onClick={onCloseErrorAlert}
              >
                <CloseIcon theme={theme} />
              </div>
            </div>
            <div className="error-modal-contain-container">
              <div className="description-section">
                <Typography
                    label="An error occurred. Please try again later."
                    variant="h6Medium"
                    styles="custom-typography-style"
                />
              </div>

              <div className="error-modal-btn-section">
                <Button
                    label="Okay"
                    icon={false}
                    type="score"
                    onClick={onCloseErrorAlert}
                    styles="custom-modal-btn"
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
  );
};
